import { create } from "zustand";

interface FYState {
  selected: string;
  serverCurrent: string;
  setSelected: (fy: string) => void;
  setServerCurrent: (fy: string) => void;
}

const computeFY = (d: Date) => {
  const y = d.getFullYear();
  const start = d.getMonth() >= 3 ? y : y - 1;
  return `${start}-${String((start + 1) % 100).padStart(2, "0")}`;
};

const bootstrap = computeFY(new Date());

export const FY_ALL = "ALL";

export const useFYStore = create<FYState>((set) => ({
  selected: FY_ALL,
  serverCurrent: bootstrap,
  setSelected: (fy) => set({ selected: fy }),
  setServerCurrent: (fy) => set({ serverCurrent: fy }),
}));
